var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nucleo-loader"},[_c('div',{staticClass:"nucleotide"},[_c('nucleotide',{staticClass:"nucleotide-img"})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }